<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && Object.keys(userTracker).length===0">{{ $t('tracker.no_tracker_available' )}}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xs12 sm12 md6 lg4 xl3 v-for="s in trackers" :key="s.key">
      <tracker-item :tracker="s" :eventlog="trackerEventlog[s.device]" @click="onTrackerClicked(s)"></tracker-item>
    </v-flex>
  </v-layout>

  <v-btn color="secondary" dark fixed bottom right fab @click="createTracker" v-if="!loading && limitCount">
    <v-icon>add</v-icon>
  </v-btn>

  <tracker-editor v-if="dialogEditor" v-model="dialogEditor" :data="dialogEditorItem"></tracker-editor>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import DeviceItem from '@/components/device/DeviceItem'
import TrackerEditorDialog from './TrackerEditorDialog'
import TrackerItem from './TrackerItem'

export default {
  name: 'Tracker',
  mixins: [UserAuth],
  components: {
    'device-item': DeviceItem,
    'tracker-editor': TrackerEditorDialog,
    'tracker-item': TrackerItem
  },
  data() {
    return {
      dialogEditorItem: null,
      dialogEditor: false,
    }
  },
  computed: {
    loading() {
      return this.trackerLoading;
    },
    trackers() {
      return Object.keys(this.userTracker).map(key => {
        let tracker = this.userTracker[key];
        let deviceId = tracker.device;
        let [mac, uid, cid] = deviceId.split('-');
        let d = (((this.userDevice[mac] || {})[`${mac}-${uid}`] || {}).channel || {})[deviceId] || {};
        return {
          key: key,
          deviceInfo: {
            hostname: (this.userMacInfo[mac] || {}).hostname,
            targetName: ((this.userTargetName[mac] || {})[uid] || {})[cid],
            ...d
          },
          ...this.userTracker[key]
        }
      })
    },
    trackerEventlog() {
      let eventlog = {};
      Object.values(this.userTracker).forEach(t => {
        eventlog[t.device] = {
          basicvalue: t.value
        };
      });
      return eventlog;
    },
    limitCount() {
      return Object.keys(this.userTracker).length < 20;
    }
  },
  methods: {
    createTracker() {
      this.onTrackerClicked(null);
    },
    onTrackerClicked(item) {
      this.dialogEditorItem = item;
      this.dialogEditor = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tracker/Tracker.vue